<template>
  <div class="vacancies">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row">
              <div class="col-sm-10">
                <h3>{{app.vacancy.jobProfile.title}} - {{app.applicant.firstName}} {{app.applicant.lastName}}</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item active">Application</li>
                </ul>
              </div>
              <div class="col-sm-2 padTop53">
                    <a class="btn btn-white btn-sm btn-rounded" v-if="app.status == 0"
                            aria-expanded="false">
                            <i class="fa fa-dot-circle-o text-purple"></i> Shortlisted
                          </a>
                    <a class="btn btn-white btn-sm btn-rounded" v-if="app.status == 6"
                            aria-expanded="false">
                            <i class="fa fa-dot-circle-o text-purple"></i> Related
                          </a>
                    <a class="btn btn-white btn-sm btn-rounded" v-if="app.status == 1"
                            aria-expanded="false">
                            <i class="fa fa-dot-circle-o text-success"></i> Accepted
                          </a>
                    <a class="btn btn-white btn-sm btn-rounded" v-if="app.status == 2"
                            aria-expanded="false">
                            <i class="fa fa-dot-circle-o text-info"></i> Test
                          </a>
                    <a class="btn btn-white btn-sm btn-rounded" v-if="app.status == 3"
                            aria-expanded="false">
                            <i class="fa fa-dot-circle-o text-info"></i> Interview Scheduling
                          </a>
                    <a class="btn btn-white btn-sm btn-rounded" v-if="app.status == 4"
                            aria-expanded="false">
                            <i class="fa fa-dot-circle-o text-info"></i> Interview 
                          </a>
                    <a class="btn btn-white btn-sm btn-rounded" v-if="app.status == 5"
                            aria-expanded="false">
                            <i class="fa fa-dot-circle-o text-info"></i> Negotiation
                          </a>
                    <a class="btn btn-white btn-sm btn-rounded" v-if="app.status == 6"
                            aria-expanded="false">
                            <i class="fa fa-dot-circle-o text-info"></i> Medical
                          </a>
                    <a class="btn btn-white btn-sm btn-rounded" v-if="app.status == 8"
                            aria-expanded="false">
                            <i class="fa fa-dot-circle-o text-danger"></i> Rejected 
                          </a>
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <div class="row">
            <div class="col-md-12">
              <div class="card">
                <div class="card-body">
                  <timeline
                    @selectTimeline="selectTimeline"
                    :timeline_data="timeline_data"
                    :active_timeline="activeTimeline"
                    :selected_timeline="selectedTimeline"
                  ></timeline>
                  <div class="row">
                      <div class="col-md-8">
                      <application-general :app="app" :currentOffice="currentOffice" :openSkill="openSkill" @update="app = $event;"></application-general>
                      </div>
                      <div class="col-md-4">
              <div class="card">
                <div class="card-body">
                  <div v-if="selectedTimeline == 0">
                    <applications-tl-one :app="app" :currentOffice="currentOffice" @update="app = $event;" :action="(app.vacancy.vacancysettings.careerTestingChecked) ? NextToApptitude : NextToInterviewScheduling"></applications-tl-one>
                  </div>
                  <div v-if="selectedTimeline == 2">
                    <applications-tl-four :app="app" :currentOffice="currentOffice" @update="app = $event;" :interviewers="interviewers" :add="AddInterviewer" :remove="RemoveInterviewer" :action="RequestScheduleDate"></applications-tl-four>
                  </div>
                  <div v-if="selectedTimeline == 1">
                    <applications-tl-three :app="app" :currentOffice="currentOffice" @update="app = $event;" :action="NextToInterviewScheduling"></applications-tl-three>
                  </div>
                  <div v-if="selectedTimeline == 3">
                    <applications-tl-five :app="app" :currentOffice="currentOffice" @update="app = $event;" :interviewers="interviewers" :action="NextToNegotiation"></applications-tl-five>
                  </div>
                  <div v-if="selectedTimeline == 4">
                    <applications-tl-six :app="app" :currentOffice="currentOffice" @update="app = $event;" :action="NextToMedical"></applications-tl-six>
                  </div>
                  <div v-if="selectedTimeline == 5">
                    <applications-tl-seven :app="app" :currentOffice="currentOffice" @update="app = $event;" :action="DecideResult"></applications-tl-seven>
                  </div>
              
              <button type="button" v-if="app.status != 8" class="btn btn-danger btn-lg btn-block mt-5" style="border-radius: 0" @click="openReject">Reject<i class="la la-uncheck ml-2"></i></button>

              <button type="button" v-if="app.status == 8" class="btn btn-secondary btn-lg btn-block mt-5" style="border-radius: 0" @click="reconsiderApplication">Re Consider<i class="la la-check ml-2"></i></button>
                </div>
              </div>
                      </div>
                  </div>
                  </div>
                    
                  </div>
                </div>
            </div>
            <skill-modal
          :model="app.applicationSkills"
          :dialog="skillDialog"
          v-if="skillDialog"
          :method="closeSkill"
        ></skill-modal>
        <v-dialog v-model="rejectDialog" max-width="500px">
              <div class="modal-content">
                <div class="modal-body">
                  <div class="form-header">
                    <h3>Reason</h3>
                    <textarea rows="4" class="form-control" v-model="app.rejectReason" />
                  </div>
                  <div class="modal-btn delete-action">
                    <div class="row">
                      <div class="col-6">
                        <a
                          class="btn btn-primary continue-btn"
                          @click="rejectApplication()"
                          data-dismiss="modal"
                          >Reject</a
                        >
                      </div>
                      <div class="col-6">
                        <a
                          class="btn btn-primary cancel-btn"
                          @click="closeReject()"
                          >Cancel</a
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          </v-dialog>
          </div>
          <!-- /Page Content -->
        </div>
      </div>
      <!-- /Page Wrapper -->
    </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import Timeline from "@/components/reusables/timeline.vue";
import ApplicationGeneral from "@/components/applications/general.vue";
import ApplicationEvaluation from "@/components/applications/evaluation.vue";
import ApplicationsTlOne from "@/components/applications/applications-timeline-one.vue";
import ApplicationsTlTwo from "@/components/applications/applications-timeline-two.vue";
import ApplicationsTlThree from "@/components/applications/applications-timeline-three.vue";
import ApplicationsTlFour from "@/components/applications/applications-timeline-four.vue";
import ApplicationsTlFive from "@/components/applications/applications-timeline-five.vue";
import ApplicationsTlSix from "@/components/applications/applications-timeline-six.vue";
import ApplicationsTlSeven from "@/components/applications/applications-timeline-seven.vue";
import SkillModal from "@/components/applications/SkillModal.vue"
import { jobService } from '@/services/jobService';
import { authenticationService } from "@/services/authenticationService";
import Vue from "vue";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Timeline,
    SkillModal,
    ApplicationGeneral,
    ApplicationEvaluation,
    ApplicationsTlOne,
    ApplicationsTlTwo,
    ApplicationsTlThree, ApplicationsTlFour,ApplicationsTlFive,ApplicationsTlSix, 
    ApplicationsTlSeven
  },
  data() {
    return {
      timeline_data: [
        {
          name: "General",
          value: "",
          status: "active",
          id: 0
        },
        {
          name: "Interview Scheduling",
          value: "",
          status: "inactive",
          id: 2
        },
        {
          name: "Interview",
          value: "",
          status: "inactive",
          id: 3
        },
        {
          name: "Offer",
          value: "",
          status: "inactive",
          id: 4
        },
        {
          name: "Medical",
          value: "",
          status: "inactive",
          id: 5
        }
      ],
      activeTimeline: 0,
      selectedTimeline: 0,
      currentOffice: authenticationService.currentOfficeValue,
      dataunsaved: false,
      skillDialog: false,
      rejectDialog: false,
      app: {
        applicant: {},
        vacancy: {
          jobProfile: {},
          vacancysettings: {}
        },
        applicationSkills: []
      },
      interviewers:[]
    };
  },
  watch: {
    'app': {
      handler: function(after, before) {
        if(after != before)
        this.dataunsaved = true
      },
      deep: true
    }
  },
  created() {
    this.selectedTimeline = this.activeTimeline;
  },
  methods: {
    openSkill(){
      this.skillDialog = true
    },
    closeSkill(){
      this.skillDialog = false
    },
    openReject(){
      this.rejectDialog = true
    },
    closeReject(){
      this.rejectDialog = false
    },
    selectTimeline(event) {
      this.selectedTimeline = event;
      // console.log("clicked", event);
    },
    getApplication(){
      jobService.getApplication(this.$route.params.id)
        .then(
          m => {
            this.app = m
            const hostname = document.location.protocol + "//" + document.location.host;
            if(this.app.applicationInterviewScheduling){
              this.app.applicationInterviewScheduling.customMessage = "<p>Hi "+this.app.applicant.firstName+", <br/> We'd like to invite you to interview with the "+this.currentOffice.name+" hiring team for "+this.app.vacancy.jobProfile.title+". We've suggested a date for the interview, please login to applicant portal and respond with your preferred date and time. <br /> <a href=\""+hostname+"/applicant-login\">Click here to respond</a> <br/> We look forward to hearing from you soon. </p>"
            }
            if(m.vacancy.vacancysettings.careerTestingChecked){
              this.timeline_data.push({name: "Test", value: "", status: "inactive", id: 1 })
            }
            this.timeline_data.sort((a, b) => (a.id > b.id) ? 1 : -1)
            this.activeTimeline = this.getTimeline(m.status)
            this.selectedTimeline = this.activeTimeline;
            jobService.getApplicationInterviewers(this.app.id)
            .then(
                m => {
            this.interviewers = m
          }
              )
          }
        )
    },
    getTimeline(status) {
      switch(status) {
        case 0:
          return 0;
        case 2:
          return 1;
        case 3:
          return 2;
        case 4:
          return 3;
        case 5:
          return 4;
        case 6:
          return 5;
        case 1:
          return 5;
        default:
          return 0
      }
    },
    async NextToInterviewScheduling(){
      await this.updateStage(this.app)
      this.app.applicationInterviewScheduling = {
        applicationId: this.app.id
      }
      jobService.createApplicationInterviewScheduling(this.app.id, this.app.applicationInterviewScheduling)
        .then(
          m => {
            jobService.getApplication(this.app.id)
            .then(
                m => {
            this.app = m
            const hostname = document.location.protocol + "//" + document.location.host;
            if(this.app.applicationInterviewScheduling){
              this.app.applicationInterviewScheduling.customMessage = "<p>Hi "+this.app.applicant.firstName+", <br/> We'd like to invite you to interview with the "+this.currentOffice.name+" hiring team for "+this.app.vacancy.jobProfile.title+". We've suggested a date for the interview, please login to applicant portal and respond with your preferred date and time. <br /> <a href=\""+hostname+"/applicant-login\">Click here to respond</a> <br/> We look forward to hearing from you soon. </p>"
            }
            this.timeline_data.sort((a, b) => (a.id > b.id) ? 1 : -1)
            this.activeTimeline = this.getTimeline(m.status)
            this.selectedTimeline = this.activeTimeline;
              }
              )
          }
        )
      this.dataunsaved = false;
    },
    async RequestScheduleDate(){
  
      jobService.sendScheduleRequest(this.app.applicationInterviewScheduling)
        .then(
          m => {
            jobService.getApplication(this.$route.params.id)
        .then(
          m => {
            this.app = m
            const hostname = document.location.protocol + "//" + document.location.host;
            if(this.app.applicationInterviewScheduling){
              this.app.applicationInterviewScheduling.customMessage = "<p>Hi "+this.app.applicant.firstName+", <br/> <br/> We'd like to invite you to interview with the "+this.currentOffice.name+" hiring team for "+this.app.vacancy.jobProfile.title+". We've suggested a date for the interview, please login to applicant portal and respond with your preferred date and time. <br /> <br/> <a href=\""+hostname+"/applicant-login\">Click here to respond</a> <br/> <br/> We look forward to hearing from you soon. </p>"
            }
          }
        )
          }
        )
      this.dataunsaved = false;
    },
    async AddInterviewer(employeeId){
     var applicationInterviewer = {
        applicationId: this.app.id,
        employeeId: employeeId
      }
      jobService.createApplicationInterviewer(applicationInterviewer)
        .then(
          m => {
            jobService.getApplicationInterviewers(this.app.id)
            .then(
                m => {
            this.interviewers = m
          }
              )
          }
        )
      this.dataunsaved = false;
    },

    async RemoveInterviewer(interviewerId){
      jobService.removeApplicationInterviewer(interviewerId)
        .then(
          m => {
            jobService.getApplicationInterviewers(this.app.id)
            .then(
                m => {
            this.interviewers = m
          }
              )
          }
        )
      this.dataunsaved = false;
    },

    async NextToApptitude(){
      await this.updateStage(this.app)
      this.app.applicationScore = {
        applicationId: this.app.id
      }
      jobService.createApplicationScore(this.app.id, this.app.applicationScore)
        .then(
          m => {
            jobService.getApplication(this.app.id)
            .then(
                m => {
            this.app = m
            const hostname = document.location.protocol + "//" + document.location.host;
            if(this.app.applicationInterviewScheduling){
              this.app.applicationInterviewScheduling.customMessage = "<p>Hi "+this.app.applicant.firstName+", <br/> <br/> We'd like to invite you to interview with the "+this.currentOffice.name+" hiring team for "+this.app.vacancy.jobProfile.title+". We've suggested a date for the interview, please login to applicant portal and respond with your preferred date and time. <br /> <br/> <a href=\""+hostname+"/applicant-login\">Click here to respond</a> <br/> <br/> We look forward to hearing from you soon. </p>"
            }
            this.timeline_data.sort((a, b) => (a.id > b.id) ? 1 : -1)
            this.activeTimeline = this.getTimeline(m.status)
            this.selectedTimeline = this.activeTimeline;
          }
              )
          }
        )
      this.dataunsaved = false;
    },

    async NextToNegotiation(){
      await this.updateStage(this.app)
      this.app.applicationNegotiation = {
        applicationId: this.app.id
      }
      jobService.createApplicationNegotiation(this.app.id, this.app.applicationNegotiation)
        .then(
          m => {
            jobService.getApplication(this.app.id)
            .then(
                m => {
            this.app = m
            const hostname = document.location.protocol + "//" + document.location.host;
            if(this.app.applicationInterviewScheduling){
              this.app.applicationInterviewScheduling.customMessage = "<p>Hi "+this.app.applicant.firstName+", <br/> <br/> We'd like to invite you to interview with the "+this.currentOffice.name+" hiring team for "+this.app.vacancy.jobProfile.title+". We've suggested a date for the interview, please login to applicant portal and respond with your preferred date and time. <br /> <br/> <a href=\""+hostname+"/applicant-login\">Click here to respond</a> <br/> <br/> We look forward to hearing from you soon. </p>"
            }
            this.timeline_data.sort((a, b) => (a.id > b.id) ? 1 : -1)
            this.activeTimeline = this.getTimeline(m.status)
            this.selectedTimeline = this.activeTimeline;
          }
              )
          }
        )
      this.dataunsaved = false;
    },

    async DecideResult(){
      if(this.app.applicationMedical.result  == 1) {
        this.acceptApplication();
      }else{
        this.rejectApplication();
      }
    },
    async NextToMedical(){
      await this.updateStage(this.app)
            jobService.getApplication(this.app.id)
            .then(
                m => {
            this.app = m
            const hostname = document.location.protocol + "//" + document.location.host;
            if(this.app.applicationInterviewScheduling){
              this.app.applicationInterviewScheduling.customMessage = "<p>Hi "+this.app.applicant.firstName+", <br/> We'd like to invite you to interview with the "+this.currentOffice.name+" hiring team for "+this.app.vacancy.jobProfile.title+". We've suggested a date for the interview, please login to applicant portal and respond with your preferred date and time. <br /> <a href=\""+hostname+"/applicant-login\">Click here to respond</a> <br/> We look forward to hearing from you soon. </p>"
            }
            this.timeline_data.sort((a, b) => (a.id > b.id) ? 1 : -1)
            this.activeTimeline = this.getTimeline(m.status)
            this.selectedTimeline = this.activeTimeline;
              }
              )
      this.dataunsaved = false;
    },
    async updateStage(application){
      if(application.status == 2){
        await jobService.updateApplicationScore(application.applicationScore);
      }else if(application.status == 5){
        application.applicationNegotiation.status = 1;
        await jobService.updateApplicationNegotiation(application.applicationNegotiation);
      }

    },

    async acceptApplication() {
      await this.updateStage(this.app)
      this.app.status = 1
      jobService.updateApplication(this.app)
      .then(
          m => {
            return this.$router.push('/onboarding');
          }
      )
      this.dataunsaved = false;
    },

    rejectApplication() {
      this.app.status = 8
      jobService.updateApplication(this.app)
        .then(
          m => {
            this.closeReject()
            jobService.getApplication(this.$route.params.id)
            .then(
                m => {
            this.app = m
            this.timeline_data.sort((a, b) => (a.id > b.id) ? 1 : -1)
            this.activeTimeline = this.getTimeline(m.status)
            this.selectedTimeline = this.activeTimeline;
          }
              )
          }
        )
      this.dataunsaved = false;
    },

    async reconsiderApplication() {
      this.app.status = (this.app.applicationNegotiation) ? 5 : (this.app.applicationInterviewScheduling.confirmedDate !== undefined) ? 4 : (this.app.applicationInterviewScheduling.confirmedDate === undefined) ? 3 : (this.app.applicationScore) ? 2 : 1;
      if(this.app.status == 5){
        this.app.applicationNegotiation.status = 0;
        await jobService.updateApplicationNegotiation(this.app.applicationNegotiation);
      }
      jobService.updateApplication(this.app)
        .then(
          m => {
            jobService.getApplication(this.$route.params.id)
            .then(
                m => {
            this.app = m
            this.timeline_data.sort((a, b) => (a.id > b.id) ? 1 : -1)
            this.activeTimeline = this.getTimeline(m.status)
            this.selectedTimeline = this.activeTimeline;
          }
              )
          }
        )
      this.dataunsaved = false;
    }

  },
  mounted() {
    this.getApplication()
  },
  beforeRouteLeave (to, from, next) {
    if(this.dataunsaved){
      const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
      if(answer){
        next()
      }else{
        next(false)
      }
    }
  },
  name: "application-detail"
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/applications/details-page.vue